import Controller from "@ember/controller";

export default class ChatDraftChannelController extends Controller {}
